<template>
  <a-tooltip>
    <template slot="title">{{type == 'raw' ? '配方' :'营养需要量'}}显示列</template>
    <a-dropdown>
      <!-- <a-button icon="filter" type="link"/> -->
      <a-button type="link">
        <img :src="filterConditions" :alt="type == 'raw' ? '配方' :'营养需要量' + '显示列'" />
      </a-button>
      <a-menu slot="overlay" class="menu">
        <a-checkbox-group :defaultValue="defuaultValue" name="checkboxgroup" :options="options" @change="listChange" />
      </a-menu>
    </a-dropdown>
  </a-tooltip>
</template>

<script>
import { nhfMixins } from '../../untils'
import nutColumns from './nutColumns'
import rawColumns from './rawColumns'
import filterConditions from '@/assets/images/icon/filterConditions.png'

export default {
  props:['type'],
  mixins:[nhfMixins],
  data(){
    return {
      filterConditions, // icon
      col:{
        nut:nutColumns,
        raw:rawColumns
      },
    }
  },
  computed:{
    defuaultValue(){
      const {type,rawTableColShow,nutTableColShow} = this
      let defaultValue = []
      if(type == 'raw') defaultValue = rawTableColShow
      if(type == 'nut') defaultValue = nutTableColShow
      return defaultValue
    },
    options(){
      return this.col[this.type].map(i=>{
        i.label = i.title || i.newTitle
        i.value = i.dataIndex
        return i
      })
    }
  },
  methods:{
    listChange(val){
      const {type} = this
      if(type == 'raw') {
        window.localStorage.setItem('rawTableColShow', val)
        this.setState({rawTableColShow:val})
      }
      if(type == 'nut') {
        window.localStorage.setItem('nutTableColShow',val)
        this.setState({nutTableColShow:val})
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .menu {
    padding:5px 15px;
    ::v-deep .ant-checkbox-group-item{
      display: block;
      margin:10px 0;
    }
  }
</style>
